import ContentContainer from 'Components/Container/ContentContainer'
import { MasterHeader, SubDescriptionLight, Title } from 'Components/CustomComponents'
import styles from "../styles/Routes.module.scss"

interface RouteComponentProps {
    round: string;
    currentRound: number;
    totalRound: number;
}

const RouteComponent: React.FC<RouteComponentProps> = ({ round, currentRound, totalRound }) => {
    return (
            <ContentContainer bg='#f5f5f5' style={{ minWidth: "206px" }}>
                <MasterHeader
                    text={round}
                    classes='fs-5 mb-2'
                />
                <ContentContainer classes={`p-3 ${styles.innerContainer}`}>
                    <SubDescriptionLight
                        text="Total Stops"
                        classes={styles.totalStops}
                    />
                    <div className='d-flex flex-row gap-1'>

                        <Title
                            text={currentRound as unknown as string}
                            classes={`mb-1 fs-3 ${styles.count}`}
                        />
                        <Title
                            text="/"
                            classes={`mb-1 fs-3 `}
                        />

                        <Title
                            text={totalRound as unknown as string}
                            classes={`mb-1 fs-3 `}
                        />
                    </div>

                </ContentContainer>
            </ContentContainer>
    )
}

export default RouteComponent